import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { CycleService } from './services/cycle.service';
import { CycleEffects } from './store/effects/cycle.effects';
import * as cycleReducer from './store/reducers/cycle.reducer';

export function provideCycleFeature() {
  return makeEnvironmentProviders([
    provideState('cycleModule', cycleReducer.reducer),
    provideEffects(CycleEffects),
    CycleService,
  ]);
}
